import { AvatarAccordionProps } from "./types"
import React from "react"
import { Accordion } from "~widgets/accordion"
import { Avatar } from "~widgets/avatar"
import styled from '~/ui/styled'

const LeftIconWrap = styled.Pressable`
  margin-right: 10px;
`

const AvatarAccordion: React.FC<AvatarAccordionProps> = ({
  accordionProps,
  avatarProps,
  onAvatarPress,
  children,
}) => {
  return (
    <Accordion {...accordionProps}>
      <LeftIconWrap onClick={() => onAvatarPress?.()}>
        <Avatar {...avatarProps} />
      </LeftIconWrap>
      {children}
    </Accordion>
  )
}
export default AvatarAccordion
